<template>
    <div>
        <header>
            <div class="top">
                <div class="top-content">
                    <h1>{{ $t("index.homeTitle") }}</h1>
                    <div class="h3">{{ $t("index.homeSubTitle") }}</div>
                    <p class="top-content1"></p>
                    <div class="top-content2">
                        {{ $t("index.homeNavP1") }}
                    </div>
                    <div class="top-content3">
                        {{ $t("index.homeNavP2") }}
                    </div>
                    <div
                        style="
                           
                        "
                        class="page-top-btn"
                    >
                        <p
                            class="top-content4"
                            @click="btnshow = !btnshow"
                        >
                            {{ $t("index.homeNavP1button") }}
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/detail.png" alt="" />
                        </p>
                        <p class="top-content5" @click="goExam">
                            {{ $t("index.homeNavP2button") }}
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/detail1.png" alt="" />
                        </p>
                    </div>
                </div>
            </div>
        </header>
        <div class="content">
            <h2 class="content-2" ref="id2">
                <!-- <span class="section-title">
                    <div class="ellipse-line"></div>
                    {{ $t("index.examModulesTitle") }}
                </span> -->
                <div class="dot-matrix-gradient"></div>
                {{ $t("index.examModulesTitle") }}
                <div class="dot-matrix-gradient"></div>
            </h2>
            <div class="exam-section">
                <div class="exam-details">
                    <div class="detail-card">
                        <div class="top">
                            <!-- <img
                                src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg1.png"
                                alt=""
                            /> -->
                            <div class="text">
                                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg1-1.png" alt="" />
                                {{ $t("index.spoken") }}
                            </div>
                        </div>
                        <div class="bottom">
                            <p class="p1">
                                {{ $t("index.form")
                                }}{{ $t("index.FormatOffline") }}
                            </p>
                            <p class="p1">
                                {{ $t("index.Duration")
                                }}{{ $t("index.Approximately") }}15{{
                                    $t("index.minutes")
                                }}
                            </p>
                            <p class="p2">{{ $t("index.questionType") }}</p>
                            <ul>
                                <li>Interview</li>
                                <li>Voice message</li>
                                <li>Summary</li>
                                <li>Debate</li>
                                <li>Follow-up questions</li>
                            </ul>
                        </div>
                    </div>

                    <div class="detail-card">
                        <div class="top">
                            <!-- <img
                                src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg2.png"
                                alt=""
                            /> -->
                            <div class="text">
                                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg1-2.png" alt="" />
                                {{ $t("index.Listening") }}
                            </div>
                        </div>
                        <div class="bottom">
                            <p class="p1">
                                {{ $t("index.form")}}{{ $t("index.FormatOffline") }}
                            </p>
                            <p class="p1">
                                {{ $t("index.Duration") }}{{ $t("index.Approximately") }}35{{$t("index.minutes")}}
                            </p>
                            <p class="p2">{{ $t("index.questionType") }}</p>
                            <ul>
                                <li>
                                    Multiple choice with picture options or text
                                    options
                                </li>
                                <li>Note-completion</li>
                                <li>Matching</li>
                                <li>Multiple-choice with text options</li>
                            </ul>
                        </div>
                    </div>

                    <div class="detail-card">
                        <div class="top">
                            <!-- <img
                                src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg3.png"
                                alt=""
                            /> -->
                            <div class="text">
                                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg1-3.png" alt="" />
                                {{ $t("index.Reading") }}
                            </div>
                        </div>
                        <div class="bottom">
                            <p class="p1">
                                {{ $t("index.form")}}{{ $t("index.FormatOffline") }}
                            </p>
                            <p class="p1">
                                {{ $t("index.Duration") }}{{ $t("index.Approximately") }}35{{$t("index.minutes")}}
                            </p>
                            <p class="p2">{{ $t("index.questionType") }}</p>
                            <ul>
                                <li>
                                    Multiple-choice questions on short texts
                                </li>
                                <li>Multiple- matching</li>
                                <li>Gapped text</li>
                                <li>
                                    Multiple-choice questions on a longer text
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="detail-card">
                        <div class="top">
                            <!-- <div
                                src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg4.png"
                                alt=""
                            ></div> -->
                            <div class="text">
                                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg1-4.png" alt="" />
                                {{ $t("index.writing") }}
                            </div>
                        </div>
                        <div class="bottom">
                            <p class="p1">
                                {{ $t("index.form")}}{{ $t("index.FormatOffline") }}
                            </p>
                            <p class="p1">
                                {{ $t("index.Duration") }}{{ $t("index.Approximately") }}50{{ $t("index.minutes")}}
                            </p>
                            <p class="p2">{{ $t("index.questionType") }}</p>
                            <ul>
                                <li>Essay</li>
                                <li>Summary</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="exam-section">
                <h3 ref="id3">
                    <!-- <span class="section-title section-title--light"> -->
                        <div class="dot-matrix-gradient dot-matrix-gradient1"></div>
                        {{ $t("index.examBenefitsTitle") }}
                        <div class="dot-matrix-gradient dot-matrix-gradient1"></div>
                    <!-- </span> -->
                </h3>
                <div class="exam-details1">
                    <div class="detail-card1">
                        <div class="left">
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/yousi1.png" alt="" />
                        </div>
                        <div class="right">
                            <p class="p1">{{ $t("index.Certified") }}</p>
                            <p class="p1">
                                {{ $t("index.Certified1") }}
                            </p>
                        </div>
                    </div>
                    <div class="detail-card1">
                        <div class="left">
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/yousi2.png" alt="" />
                        </div>
                        <div class="right">
                            <p class="p1">{{ $t("index.Secure") }}</p>
                            <p class="p1">
                                {{ $t("index.Secure1") }}
                            </p>
                        </div>
                    </div>
                    <div class="detail-card1">
                        <div class="left">
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/yousi3.png" alt="" />
                        </div>
                        <div class="right">
                            <p class="p1">{{ $t("index.Aligned") }}</p>
                            <p class="p1">{{ $t("index.Aligned1") }}</p>
                        </div>
                    </div>
                    <div class="detail-card1">
                        <div class="left">
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/yousi4.png" alt="" />
                        </div>
                        <div class="right">
                            <p class="p1">{{ $t("index.Fast") }}</p>
                            <p class="p1">
                                {{ $t("index.Fast1") }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="exam-section" ref="id4">
                <h3 ref="id3" class="h4">
                    <div class="dot-matrix-gradient dot-matrix-gradient1"></div>
                        {{ $t("index.examDayTitle") }}
                    <div class="dot-matrix-gradient dot-matrix-gradient1"></div>
                    <!-- <span class="section-title section-title--light">{{ $t("index.examDayTitle") }}</span> -->
                </h3>
                <div ref="processBox" class="examination-process-box" :style="{ height: $i18n.locale === 'en' ? '1090px' : 'auto' }">
                    <div class="process1">
                        <div class="exam-prep-container">
                            <p class="number">1</p>
                            <h1 class="title">{{ $t("index.exam1") }}</h1>
                            <ul class="prep-list">
                                <li
                                    class="prep-item"
                                    style="align-items: flex-start"
                                >
                                    <span
                                        class="item-text"
                                        :style="$i18n.locale !== 'en' ? {
                                            display: 'flex',
                                            flexFlow: 'row',
                                            alignItems: 'flex-start',
                                            whiteSpace: 'normal'
                                        } : {}"
                                    >
                                        <span style="flex-shrink: 0; white-space: nowrap; margin-right: 6px;">{{
                                            $t("index.exam2")
                                        }}</span>
                                        <span style="min-width: 0; white-space: normal;" v-if="currentLocale !== 'en'">
                                            <span class="custom-underline">
                                                8:45-9:30 {{ $t("index.exam26") }}
                                            </span>
                                           (9:30 {{ $t("index.exam4") }}) 
                                        </span>
                                        <span style="min-width: 0; white-space: normal;" v-else>
                                          Check-in from 
                                           <span class="custom-underline">
                                                08:45 to 09:30
                                            </span>
                                           . Entry closes at 09:30.
                                        </span>
                                    </span>
                                </li>
                                <li
                                    class="prep-item"
                                    style="align-items: flex-start"
                                >
                                    <span
                                        class="item-text"
                                        :style="$i18n.locale !== 'en' ? {
                                            display: 'flex',
                                            flexFlow: 'row',
                                            alignItems: 'flex-start',
                                            whiteSpace: 'normal'
                                        } : {}"
                                    >
                                        <span style="flex-shrink: 0; white-space: nowrap; margin-right: 6px;">{{
                                            $t("index.exam5")
                                        }}</span>
                                        
                                        <span style="min-width: 0; white-space: normal;" v-if="currentLocale !== 'en'">
                                            <span class="custom-underline">
                                                13:45-14:30 {{ $t("index.exam26") }}
                                            </span>
                                            (14:30{{ $t("index.exam4") }})
                                        </span>
                                         <span style="min-width: 0; white-space: normal;" v-else>
                                            Check-in from<span class="custom-underline" style="display: inline-block; margin-left: 4px;">
                                                13:45 to 14:30
                                            </span>. Entry closes at 14:30.
                                        </span>
                                    </span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam28")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="exam-prep-container">
                            <p class="number">2</p>
                            <h1 class="title">{{ $t("index.exam23") }}</h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam7")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam8")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam9")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="exam-prep-container">
                            <p class="number">3</p>
                            <h1 class="title">{{ $t("index.exam12") }}</h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text" v-if="currentLocale !== 'en'">
                                        {{ $t("index.exam10") }}
                                            <span class="custom-underline" style="display: inline-block">{{ $t("index.exam11") }}</span>
                                            {{ $t("index.exam12End") }}
                                            </span
                                            >
                                    <span class="item-text" v-else>
                                        <span class="custom-underline">
                                            Bring the original valid identity 
                                        </span>
                                        document used 
                                       for registration into the test room.
                                    </span>    
                                </li>
                                 <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam27")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam13")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam14")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam15")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="process1">
                        <div class="exam-prep-container exam-prep-container1">
                            <p class="number">6</p>
                            <h1 class="title">{{ $t("index.exam16") }}</h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.exam17")
                                        }}<span class="custom-underline">
                                            {{ $t("index.exam18") }}
                                        </span>
                                        {{ $t("index.exam19") }}
                                    </span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam20")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="exam-prep-container exam-prep-container1">
                            <p class="number">5</p>
                            <h1 class="title">{{ $t("index.exam25") }}</h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.Listening") }}: {{
                                            $t("index.Approximately")
                                        }}
                                        35 {{ $t("index.minutes") }}</span
                                    >
                                </li>
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.Reading") }}: {{
                                            $t("index.Approximately")
                                        }}
                                        35 {{ $t("index.minutes") }}</span
                                    >
                                </li>
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.writing") }}: {{
                                            $t("index.Approximately")
                                        }}
                                        50 {{ $t("index.minutes") }}</span
                                    >
                                </li>
                            </ul>
                        </div>
                        <div class="exam-prep-container exam-prep-container1">
                            <p class="number">4</p>
                            <h1 class="title">{{ $t("index.exam24") }}</h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text">
                                        {{ $t("index.exam21") }}
                                        {{ $t("index.Approximately") }} 15
                                        {{ $t("index.minutes") }}
                                    </span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam22")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="examination-process-box-mobile">
                    <div class="process1">
                        <div class="exam-prep-container">
                            <h1 class="title">
                                <p class="number">1</p>
                                {{ $t("index.exam1") }}
                            </h1>
                            <ul class="prep-list">
                                <li
                                    class="prep-item"
                                    style="align-items: flex-start"
                                >
                                    <span
                                        class="item-text"
                                        :style="$i18n.locale !== 'en' ? {
                                            display: 'flex',
                                            flexFlow: 'row',
                                            alignItems: 'flex-start',
                                            whiteSpace: 'normal'
                                        } : {}"
                                    >
                                        <span style="width: 38%">{{
                                            $t("index.exam2")
                                        }}</span>
                                        <!-- <span>
                                            <span class="custom-underline">
                                                8:45-9:30{{ $t("index.exam26") }}
                                            </span>
                                            (9:30{{ $t("index.exam4") }})
                                        </span> -->
                                        <span style="min-width: 0; white-space: normal;" v-if="currentLocale !== 'en'">
                                            <span class="custom-underline">
                                                8:45-9:30 {{ $t("index.exam26") }}
                                            </span>
                                           (9:30 {{ $t("index.exam4") }}) 
                                        </span>
                                        <span style="min-width: 0; white-space: normal;" v-else>
                                        Check-in from 
                                           <span class="custom-underline">
                                                08:45 to 09:30
                                            </span>
                                           . Entry closes at 09:30.
                                        </span>
                                    </span>
                                </li>
                                <li
                                    class="prep-item"
                                    style="align-items: flex-start"
                                >
                                    <span
                                        class="item-text"
                                        :style="$i18n.locale !== 'en' ? {
                                            display: 'flex',
                                            flexFlow: 'row',
                                            alignItems: 'space-between',
                                        } : {}"
                                    >
                                        <span style="width: 38%">{{
                                            $t("index.exam5")
                                        }}</span>
                                        <span v-if="currentLocale !== 'en'">
                                            <!-- {{ $t("index.exam3") }} -->
                                            <span class="custom-underline">
                                                13:45-14:30{{ $t("index.exam26") }}
                                            </span>
                                            (14:30 {{ $t("index.exam4") }})
                                        </span>
                                        <span style="min-width: 0; white-space: normal;" v-else>
                                            Check-in from<span class="custom-underline" style="display: inline-block;">
                                                13:45 to 14:30
                                            </span>. Entry closes at 14:30.
                                        </span>
                                    </span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam28")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/arrow.png" class="arrow arrow1" />
                        <div class="exam-prep-container">
                            <h1 class="title">
                                <p class="number">2</p>
                                {{ $t("index.exam23") }}
                            </h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam7")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam8")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam9")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <p class="arrow-box">
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/arrow.png" class="arrow arrow2" />
                    </p>
                    <div class="process1">
                        <div class="exam-prep-container">
                            <h1 class="title">
                                <p class="number">4</p>
                                {{ $t("index.exam24") }}
                            </h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text">
                                        {{ $t("index.exam21") }}
                                        {{ $t("index.Approximately") }} 15
                                        {{ $t("index.minutes") }}</span
                                    >
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam22")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/arrow.png" class="arrow arrow3" />
                        <div class="exam-prep-container">
                            <h1 class="title">
                                <p class="number">3</p>
                                {{ $t("index.exam12") }}
                            </h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.exam10") }}
                                        <span class="custom-underline">
                                            {{ $t("index.exam11") }}
                                        </span>
                                        {{ $t("index.exam12") }}</span
                                    >
                                </li>
                                 <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam27")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam13")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam14")
                                    }}</span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam15")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <p class="arrow-box arrow-box1">
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/arrow.png" class="arrow arrow4" />
                    </p>
                    <!-- <img src="@/assets/arrow.png" class="arrow arrow4"  /> -->
                    <div class="process1">
                        <div class="exam-prep-container exam-prep-container1">
                            <h1 class="title">
                                <p class="number">5</p>
                                {{ $t("index.exam25") }}
                            </h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.Listening") }}：{{
                                            $t("index.Approximately")
                                        }}
                                        35 {{ $t("index.minutes") }}</span
                                    >
                                </li>
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.Reading") }}：{{
                                            $t("index.Approximately")
                                        }}
                                        35 {{ $t("index.minutes") }}</span
                                    >
                                </li>
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.writing") }}：{{
                                            $t("index.Approximately")
                                        }}
                                        50 {{ $t("index.minutes") }}</span
                                    >
                                </li>
                            </ul>
                        </div>
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/arrow.png" class="arrow arrow1" />
                        <div class="exam-prep-container exam-prep-container1">
                            <h1 class="title">
                                <p class="number">6</p>
                                {{ $t("index.exam16") }}
                            </h1>
                            <ul class="prep-list">
                                <li class="prep-item">
                                    <span class="item-text"
                                        >{{ $t("index.exam17")
                                        }}<span class="custom-underline">
                                            {{ $t("index.exam18") }}
                                        </span>
                                        {{ $t("index.exam19") }}
                                    </span>
                                </li>
                                <li class="prep-item">
                                    <span class="item-text">{{
                                        $t("index.exam20")
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/liucheng.png" class="liucheng" alt="" style="width: 100%;">
                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/liucheng1.png" class="liucheng1" alt="" style="width: 100%;"> -->
            </div>
            <h2 class="content-2 content-mobile" ref="id2">
                <!-- <p></p>
                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/考点地址.svg" alt="" />
                <p></p> -->
                <div class="dot-matrix-gradient"></div>
                {{ $t("index.examlocation") }}
                <div class="dot-matrix-gradient"></div>
            </h2>
            <div class="exam-centers-container">
                <div class="table-container">
                    <table class="exam-centers-table">
                        <thead>
                            <tr>
                                <th>{{ $t("index.city") }}</th>
                                <th>{{ $t("index.examname") }}</th>
                                <th>{{ $t("index.examlocation") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(center, index) in examCenters"
                                :key="index"
                            >
                                <td class="city-cell">{{ center.city }}</td>
                                <td class="name-cell">{{ center.name }}</td>
                                <td class="address-cell">
                                    {{ center.address }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="exam-locations">
                <div class="location-list">
                    <div
                        v-for="(location, index) in examCenters"
                        :key="location.city + index"
                        class="location-card"
                    >
                        <div class="city-header">
                            <h2 class="city-title">{{ location.city }}</h2>
                        </div>

                        <div class="location-details">
                            <div class="location-name">{{ location.name }}</div>
                            <div class="location-address">
                                {{ location.address }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div
            class="mobileShow"
            v-if="mobileShow"
            @click.stop="mobileShow = !mobileShow"
        >
            <div class="mobileShow-box" @click.stop="">
                <div
                    style="
                        display: flex;
                        flex-flow: row;
                        align-items: center;
                        justify-content: center;
                    "
                >
                    <div class="imgbox">
                         <p class="p1">
                           添加牛津考小助手，为您提供一对一服务
                        </p>
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/老师二维码.png" alt="" />
                        <p>扫码咨询考试</p>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 自定义内容 -->
        <Modal
            :showModal="showModal"
            :show-default-content="false"
            :show-default-tips="false"
            :title='$t("selectAge.headerTitle")'
            @confirm="handleConfirm"
            @cancel="handleCancel"
        >
            <!-- 自定义内容插槽 -->
            <template #content>
                <div class="age-modal-content">
                    <h4>{{$t("selectAge.title")}}</h4>
                    <div class="radio-group">
                        <el-radio-group v-model="ageRadio" size="big">
                            <el-radio
                                :label="item.value"
                                border
                                size="medium"
                                v-for="item in options"
                                :key="item.value"
                            >
                                <template #default>
                                    <span class="custom-radio-item">
                                        <span>
                                            <!-- item.value+'.' -->
                                            {{ item.text }}
                                            <span class="item1">
                                                ({{ item.subText }})</span
                                            ></span
                                        >
                                        <i
                                            class="el-icon-success"
                                            v-if="ageRadio == item.value"
                                        ></i>
                                        <i class="nocheck-radio" v-else></i>
                                    </span> </template
                            ></el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </template>
            <!-- 自定义按钮插槽 -->
            <!-- <template #footer>
            <button class="btn-custom" @click="showModal2 = false">关闭</button>
            <button class="btn-submit" @click="submitCustom">提交申请</button>
        </template> -->
        </Modal>
        <!-- 自定义内容 -->
        <Modal
            :showModal="showModal1"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-submit="false"
            :show-size="ageRadio === 'B' ? '' : 'small'"
            :show-delete-icon="true"
            @confirm="handleConfirm1"
            @cancel="handleCancel1"
            :title='$t("selectAge.headerTitle")'
        >
            <template #content>
                <div class="age-modal-content">
                    <div class="tips-box">
                        <p class="p1">
                            {{
                                ageRadio === "B"
                                    ? $t("selectAge.between")
                                    : $t("selectAge.under")
                            }}
                            <!-- 未满16周岁的考生由监护人签署《考生监护人确认书》后方可继续报名。 -->
                        </p>
                        <img
                            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/老师二维码.png"
                            v-if="ageRadio === 'B'"
                        />
                        <p class="p2" v-if="ageRadio === 'B'">
                            {{ $t("selectAge.addTeacher") }}
                        </p>
                    </div>
                </div>
            </template>
        </Modal>
         <transition name="slide">
            <LoginPage :showPage="showLogin" @closeLogin="showLogin=!showLogin"></LoginPage>
         </transition>
        <Modal
            :showModal="btnshow"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-submit="false"
            show-size="small"
            :show-delete-icon="true"
            title=" "
            @confirm="handleConfirm2"
            @cancel="handleConfirm2"
        >
            <template #content>
                <div class="age-modal-content">
                    <div class="tips-box">
                        <p class="p1">
                           {{ $t("selectAge.addTeacher") }}
                        </p>
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/老师二维码.png" alt="" />
                        <p class="zx">{{$t('selectAge.scanEnquire')}}</p>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>
<script>
import Vue from "vue";
import LoginPage from "@/components/LoginPage.vue";
import { getExamRescource } from "@/plugins/api";
import { toCST, formatChinese, formatEnglishFull } from "@/utils/date";

export default Vue.extend({
    components: { LoginPage },
    data() {
        return {
            navList: [
                { id: 1, text: "首页" },
                { id: 2, text: "考试介绍" },
                { id: 3, text: "考试优势" },
                { id: 4, text: "考试流程" },
                { id: 5, text: "关于我们" },
            ],
            activeIndex: 1,
            mobileNav: false,
            isMobileNavOpen: false,
            btnshow: false,
            examCentersCN: [
                { city: "北京", name: "北京望京考点", address: "北京市朝阳区望京东园523号融科望京中心A座809室" },
                { city: "天津", name: "天津工业大学考点", address: "天津市西青区宾水西道399号天津工业大学经管学院129室" },
                { city: "郑州", name: "郑州正弘考点", address: "河南省郑州市金水区花园路126号正弘中心11层Vip1室" },
                { city: "杭州", name: "杭州黄龙考点", address: "杭州市西湖区黄龙万科中心A座14楼CentreRoom" },
                { city: "杭州", name: "杭州奥体考点", address: "浙江省杭州市萧山区盈丰街道奔竞大道227号新闻中心1-M01,2-M01,3-M01米德尔顿学院3楼" },
                { city: "宁波", name: "宁波美锦考点", address: "浙江省宁波市鄞州区首南街道美锦大厦601室" },
                { city: "成都", name: "成都三友岛考点", address: "四川省成都成华区三友路3号1栋三友岛文创园区1层1-6" },
                { city: "上海", name: "上海世茂考点", address: "上海市浦东新区潍坊西路55号上海世茂大厦16层1662室" },
                { city: "上海", name: "上海外滩SOHO考点", address: "上海市黄浦区外滩街道中山东二路88号外滩SOHO-C座9层902室" },
                { city: "无锡", name: "无锡海岸城考点", address: "江苏省无锡市经开区立信大道168号海岸城写字楼33层3305室" },
                { city: "深圳", name: "深圳荣超国际考点", address: "广东省深圳市福田区福华三路168号荣超国际商会中心46楼4609室" },
                { city: "厦门", name: "厦门海峡明珠考点", address: "福建省厦门市思明区宜兰路99号33层3304-2室" },
                { city: "南京", name: "南京金鹰世界考点", address: "江苏省南京市建邺区应天大街888号金鹰世界A座46层" },
                { city: "武汉", name: "武汉鼎创国际考点", address: "湖北省武汉市东湖新技术开发区黄龙山南路2号鼎创国际4栋708室" },
                { city: "广州", name: "广州海珠考点", address: "广州市海珠区东晓路536号101房自编之十二" },
                { city: "海口", name: "海口兴业城考点", address: "海南省海口市秀英区兴贸路兴业城2号楼3楼309室" },
                { city: "西安", name: "西安小寨考点", address: "西安市雁塔区长安中路38号小寨领绣城17层1708室" },
            ],
            examCentersEN: [
                { city: "Beijing", name: "Beijing Wangjing Test Centre", address: "Room 809, Tower A, Rongke Wangjing Center, No. 523, Dongyuan, Wangjing, Chaoyang District, Beijing" },
                { city: "Tianjin", name: "Tiangong University Test Centre", address: "School of Economics and Management, Tiangong University, No. 399, Binshui West Road, Xiqing District, Tianjin, 300387" },
                { city: "Zhengzhou", name: "Zhengzhou Zhenghong Test Centre", address: "11th Floor, Zhenghong Center, No. 126, Huayuan Road, Jinshui District, Zhengzhou, Henan Province" },
                { city: "Hangzhou", name: "Hangzhou Huanglong Test Centre", address: "14th Floor, Tower A, Huanglong Vanke Center, Xihu District, Hangzhou, China" },
                { city: "Hangzhou", name: "Hangzhou Olympic Test Centre", address: "Room 301, 3/F, News Center, No. 227 Benjing Avenue, Yingfeng Subdistrict, Xiaoshan District, Hangzhou, Zhejiang Province, China" },
                { city: "Ningbo", name: "Ningbo Meijin Test Centre", address: "Room 601, Meijin Building, Shounan Street, Yinzhou District, Ningbo, China" },
                { city: "Chengdu", name: "Chengdu Sanyoudao Test Centre", address: "No. 1\u20136, 1st Floor, Building 1, No. 3 Sanyou Road, Sanyoudao Cultural & Creative Park, Chenghua District, Chengdu, Sichuan Province" },
                { city: "Shanghai", name: "Shanghai Shimao Test Centre", address: "No. 55, Weifang West Road, Pudong New District, Shanghai, 200001" },
                { city: "Shanghai", name: "Shanghai Bund SOHO Test Centre", address: "Room 902, 9th Floor, Building C, Bund SOHO, No. 58 Zhongshan East 2nd Road, Huangpu District, Shanghai, China" },
                { city: "Wuxi", name: "Wuxi Coastal City Test Centre", address: "Room 3305, 33rd Floor, Coastal City Office Tower, No. 168 Lixin Avenue, Economic Development Zone, Wuxi, Jiangsu, China" },
                { city: "Shenzhen", name: "Shenzhen Rongchao International Test Centre", address: "Room 4609, 46th Floor, Rongchao International Chamber of Commerce Center, No. 168 Fuhua 3rd Road, Futian District, Shenzhen, Guangdong Province, China" },
                { city: "Xiamen", name: "Xiamen Haixiamingzhu Test Centre", address: "Room 3304-2, 33rd Floor, No. 99 Yilan Road, Siming District, Xiamen, Fujian, China" },
                { city: "Nanjing", name: "Nanjing Jinying World Test Centre", address: "Room 4601, 46th Floor, Tower A, Jinying World, No. 888 Yingtian Street, Jianye District, Nanjing, Jiangsu Province, China" },
                { city: "Wuhan", name: "Wuhan Dingchuang International Test Centre", address: "Room 708, Building 4, Dingchuang International, No. 2 Huanglongshan South Road, Donghu New & High Technology Development Zone, Wuhan, Hubei Province, China" },
                { city: "Guangzhou", name: "Guangzhou Haizhu Test Centre", address: "No. 536, Dongxiao Road, Haizhu District, Guangzhou, Guangdong Province, China" },
                { city: "Haikou", name: "Haikou Xingye City Test Centre", address: "Room 309, 3rd Floor, Building 2, Xingye City, Xingmao Road, Xiuying District, Haikou, Hainan Province, China" },
                { city: "Xi'an", name: "Xi'an Xiaozhai Test Centre", address: "Room 1708, 17th Floor, Xiaozhai Lingxiu City, No. 38 Chang'an Middle Road, Yanta District, Xi'an, Shaanxi, China" },
            ],
            showModal: false,
            showModal1: false,
            customReason: "",
            contact: "",
            ageRadio: "",
            userInfo: null,
            showLogin: false,
            options: [],
            currentLocale: 'zh-CN'
    };
  },
  computed: {
    examCenters() {
      return this.currentLocale === "en"
        ? this.examCentersEN
        : this.examCentersCN;
    },
  },
    watch: {
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
                this.$nextTick(() => this.updateProcessBoxBgSize());
            },
            immediate: true,
        },
    },
    mounted() {
        this.userInfo = this.$store.state.auth;
        if (!sessionStorage.getItem("channelCode")) {
            const channelCode = this.$route.query.channelCode;
            if (channelCode) {
                sessionStorage.setItem("channelCode", channelCode);
            } else {
                sessionStorage.removeItem("channelCode")
            }
        }
        this.$nextTick(() => {
            this.updateProcessBoxBgSize();
        });
        window.addEventListener("resize", this.updateProcessBoxBgSize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateProcessBoxBgSize);
    },
    methods: {
        updateProcessBoxBgSize() {
            // const el = this.$refs.processBox;
            // if (!el) return;
            // let height = el.offsetHeight;
            // // height = this.currentLocale === "en" ? height + 10 : el.offsetHeight;
            // el.style.backgroundSize = `100% ${height}px`;
        },
        handleConfirm(result) {
            if (this.ageRadio !== "A") {
                this.showModal1 = true;
            } else {
                // 清除所有的学生信息包括订单信息
                this.$store.dispatch("auth/updateStudentPartial", {
                    ageRadio: "A",
                    examId: [],
                    examPositionId: null,
                    checkList: [],
                    positionObj: null,
                    activeIndex: 0,
                    selecExamTime: [],
                    selectedYear: null,
                    formData: {
                        lastName: "",
                        firstName: "",
                        lastNamePy: "",
                        firstNamePy: "",
                        email: "",
                        WeChat: "",
                        credentialType: "1",
                        passport: ""
                    },
                    payNumber: null,
                    isFromOrder: false,
                    orderId: null
                });
                this.$router.push({
                    path: "/registration/Information",
                });
                // this.$router.push("/registration");
            }
        },
        handleCancel() {
            this.showModal = false;
        },
        handleConfirm1() {
            this.showModal1 = false;
        },
        handleCancel1() {
            this.showModal1 = false;
        },
        handleConfirm2() {
            this.btnshow = false
        },
        submitCustom() {
            this.showModal = false;
        },
        goExam() {
            if (window.localStorage.getItem('phone')) {
                this.generateDateOptions();
                this.showModal = true;
                this.$store.dispatch("auth/updateStudentPartial", {
                    studentInfo: null,
                });
            } else {
                this.showLogin = true;
            }
        },
        generateDateOptions() {
            const now = toCST(Date.now());
            const date16YearsAgo = now.clone().subtract(16, "years");
            const date14YearsAgo = now.clone().subtract(14, "years");

            const adjustDate = (m) => {
                const copy = m.clone();
                if (copy.month() === 1 && copy.date() > 28) {
                    copy.date(28);
                }
                return copy;
            };

            const plusOneDay = (m) => m.clone().add(1, "day");

            const locale = this.$i18n.locale || "zh-CN";
            const fmt = locale === "zh-CN" ? formatChinese : formatEnglishFull;

            this.options = [
                {
                    value: "A",
                    text: this.$t("selectAge.ageOneTitle"),
                    subText: this.$t("selectAge.ageOneSubText", {
                        date: fmt(adjustDate(date16YearsAgo).valueOf()),
                    }),
                },
                {
                    value: "B",
                    text: this.$t("selectAge.ageTwoTitle"),
                    subText: this.$t("selectAge.ageTwoSubText", {
                        start: fmt(plusOneDay(date16YearsAgo).valueOf()),
                        end: fmt(adjustDate(date14YearsAgo).valueOf()),
                    }),
                },
                {
                    value: "C",
                    text: this.$t("selectAge.ageThreeTitle"),
                    subText: this.$t("selectAge.ageThreeSubText", {
                        date: fmt(plusOneDay(date14YearsAgo).valueOf()),
                    }),
                },
            ];
        },
    },
    beforeDestroy() {},
});
</script>
<style lang="stylus" scoped>
.container {
    width: 100%;
    margin: 0 auto;
    background: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

header {
    color: white;
    background: #011E41;
    text-align: center;
}

header .top {
    min-height: 760px;
    background: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bg.png');
    // background-size: 100% auto;
    // background-repeat: no-repeat;
    background-size: contain; /* 关键属性 */
    background-position: center;
    background-repeat: no-repeat;
}

.subtitle {
    font-size: 1.4rem;
    opacity: 0.9;
    font-weight: 300;
}

.divider {
    height: 4px;
    background: linear-gradient(90deg, #1a2a6c, #b21f1f, #fdbb2d);
    margin: 5px 0 20px;
    border-radius: 2px;
}

.top-content {
    max-width: 1200px;
    margin: 0 auto;
}

.top-content h1 {
    padding-top: 126px;
    font-size: 40px;
}

.top-content .h3 {
    color: #FFFFFF;
    opacity: 0.6;
    font-size: 24px;
}

.top-content1 {
    width: 158px;
    height: 2px;
    background: #FFFFFF;
    margin: 20px auto 40px auto;
}

.top-content2, .top-content3 {
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    max-width: 950px;
    margin: 0 auto;
    text-align: justify;
    text-indent: 2em;
}

.top-content3 {
    margin-top: 20px;
    // max-width: 780px;
}

.page-top-btn {
    display: flex;
    flex-flow: row;
    justify-content: center;
    width: 860px;
    margin: 0 auto;
    display: grid;
    gap: 0;
    grid-template-columns: repeat(auto-fit, minmax(48%, 1fr));
    .top-content4, .top-content5 {
    // width: 300px;
    padding: 18px 26px;
    // height: 74px;
    background: #0043E0;
    border-radius: 37px;
    // line-height: 74px;
    background: #0043E0;
    border-radius: 40px;
    font-weight: bold;
    font-size: 28px;
    color: #FFFFFF;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    margin: 50px auto;
    transition: transform 0.3s ease;
    cursor: pointer;
    text-align: center;
}

.top-content4 img, .top-content5 img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin-left: 10px;
}

.top-content4:hover, .top-content5:hover {
    transform: translateY(-5px);
}

.top-content5 {
    background: #00AE8F;
}
}



.content {
    max-width: 1200px;
    margin: 0 auto;
}

.content-2 {
    min-height: 120px;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
    font-size: 40px;
}

.section-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 700;
    color: #011E41;
    letter-spacing: 4px;
    white-space: nowrap;

    &::before,
    &::after {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #011E41;
        border-radius: 50%;
        margin: 0 14px;
        box-shadow:
            10px 0 0 #011E41,
            20px 0 0 #011E41,
            0 10px 0 #011E41,
            10px 10px 0 #011E41,
            20px 10px 0 #011E41;
    }
}
.dot-matrix-gradient {
  width: 72px;  /* 6列 * 6px + 5个间距 * 6px = 66px */
  height: 36px; /* 3行 * 6px + 2个间距 * 6px = 30px */
  margin: 10px;
  /* 画圆点 */
  background-image: radial-gradient(circle at center, #1e3a8a 3px, transparent 2px);
  background-size: 12px 12px; /* 控制圆点之间的距离 */
  background-position: 0 0;
  /* 使用遮罩让右边变不透明，左边变透明 (实现你原图那种渐变效果) */
  -webkit-mask-image: linear-gradient(to right, rgba(255,255,255,0.1) 0%, rgba(255,255,255,1) 80%, rgba(255,255,255,1) 100%);
  mask-image: linear-gradient(to right, rgba(255,255,255,0.1) 0%, rgba(255,255,255,1) 80%, rgba(255,255,255,1) 100%);
}
.dot-matrix-gradient1 {
    background-image: radial-gradient(circle at center, #fff 3px, transparent 2px);
    -webkit-mask-image: linear-gradient(to right, rgba(255,255,255,0.1) 0%, rgba(255,255,255,1) 80%, rgba(255,255,255,1) 100%);
    mask-image: linear-gradient(to right, rgba(255,255,255,0.1) 0%, rgba(255,255,255,1) 80%, rgba(255,255,255,1) 100%);
}

.content-2 p {
    width: 180px;
    height: 2px;
    background: #011E41;
    margin: 10px;
}

.exam-section {
    /* background: #f9f9f9; */
    border-radius: 0 8px 8px 0;
    margin: 25px 0;
}

.exam-section >h3,
.exam-section .h4 {
    position: relative;
    height: 136px;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: linear-gradient(90deg, #0a1f3d 0%, #12345d 50%, #0a1f3d 100%);
    color: #fff;
    font-size: 40px;
    margin-bottom: 30px;
    overflow: hidden;
    margin: 60px 0;
    &::before,
    &::after {
        content: '';
        position: absolute;
        width: 120px;
        height: 120px;
        border: 6px solid rgba(180, 200, 100, 0.55);
        border-radius: 0;
        opacity: 0.9;
    }
}
.exam-section >h3 {
    background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/考试优势bg.png');
}
.exam-section >h4 {
    background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/考试流程bg.png');
}
.exam-section >h3::before {
    left: -30px;
    bottom: -50px;
    border-right: none;
    border-top: none;
    border-bottom-left-radius: 50px;
    border-color: rgba(120, 180, 100, 0.5);
}

.exam-section >h3::after {
    right: -30px;
    top: -50px;
    border-left: none;
    border-bottom: none;
    border-top-right-radius: 50px;
    border-color: rgba(180, 200, 100, 0.5);
}

.exam-section .h4::before {
    left: -30px;
    top: -50px;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 50px;
    border-color: rgba(180, 200, 100, 0.5);
}

.exam-section .h4::after {
    right: -30px;
    bottom: -50px;
    border-left: none;
    border-top: none;
    border-bottom-right-radius: 50px;
    border-color: rgba(120, 180, 100, 0.5);
}

.section-title--light {
    color: #fff !important;

    &::before,
    &::after {
        background: #fff !important;
        box-shadow:
            10px 0 0 #fff,
            20px 0 0 #fff,
            0 10px 0 #fff,
            10px 10px 0 #fff,
            20px 10px 0 #fff;
    }
}

.exam-section .liucheng1 {
    display: none;
}

.exam-details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
}

.exam-details1 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(49%, 1fr));
    gap: 18px;
}

.detail-card {
    background: #FFFFFF;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
    .top {
        min-height: 100px;
    }
}

.exam-details1 .detail-card1 {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: flex-start;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 1px rgba(0, 31, 104, 0.16);
    padding: 20px 14px;
    transition: transform 0.3s ease;
}

.exam-details1 .detail-card1 .left img {
    width: 124px;
    height: 86px;
}

.exam-details1 .detail-card1 .right p:first-child {
    font-weight: bold;
    font-size: 24px;
    color: #011E41;
    line-height: 33px;
}

.exam-details1 .detail-card1 .right p:last-child {
    font-weight: 400;
    font-size: 18px;
    color: #011E41;
    line-height: 33px;
}

.detail-card:hover {
    transform: translateY(-5px);
}

.detail-card1:hover {
    transform: translateY(-5px);
}

.detail-card .top {
    position: relative;
}

.detail-card .top > img {
    width: 100%;
}

.detail-card {
    .top {
        position: relative;
        .text {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0%;
            right: 0;
            bottom: 0;
            color: #fff;
            font-weight: 700;
            font-size: 30px;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: center;
            background: #011E41;

            img {
                width: 60px;
                height: 60px;
                margin-right: 2px;
            }
        }
    }

    .top:after {
        content: ' ';
        width: 100%;
        height: 8px;
        background: linear-gradient(90deg, #E2CB24 0%, #50B9AA 100%);
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
    }

    .bottom {
        padding: 16px;

        .p1 {
            font-size: 20px;
            color: #000000;
        }

        .p2 {
            font-size: 20px;
            color: #011E41;
            font-weight: bold;
            padding-left: 16px;
            position: relative;
            display: flex;
            flex-flow: row;
            align-items: center;
            margin-top: 14px;
            margin-bottom: 8px;
        }

        ul li {
            list-style: none;
            position: relative;
            padding-left: 16px;
            font-size: 16px;
            line-height: 18px;
            margin-bottom: 10px;
        }
    }
}

.detail-card .bottom .p2::after {
    content: ' ';
    position: absolute;
    left: 0;
    top: 4px;
    bottom: 0;
    right: 0;
    width: 4px;
    height: 20px;
    background: #011E41;
}

.detail-card .bottom ul li::after {
    content: ' ';
    position: absolute;
    left: 0;
    top: 28%;
    bottom: 0;
    right: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #0043E0;
}

.exam-locations {
    display: none;
}

.exam-centers-container {
    font-family: 'Microsoft YaHei', Arial, sans-serif;
    max-width: 1200px;
    margin: 20px auto 80px auto;

    // padding: 20px;
    // border-radius: 8px;
    .table-container {
        // overflow-x: auto;
    }

    .exam-centers-table {
        width: 100%;
        border-collapse: collapse;
        background-color: white;
        // border-radius: 6px;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .exam-centers-table thead {
        background-color: #2c3e50;
        border: 2px solid #CBD9DB;
    }

    .exam-centers-table th {
        color: white;
        font-weight: 600;
        text-align: left;
        padding: 16px 20px;
        font-size: 20px;
        border: 2px solid #CBD9DB;
        text-align: center;
    }

    .exam-centers-table tbody tr {
        // transition: background-color 0.2s;
    }

    .exam-centers-table tbody tr:nth-child(even) {
        background-color: #EDF8F7;
    }

    .exam-centers-table tbody tr:hover {
        // background-color: #e9f7fe;
    }

    .exam-centers-table td {
        padding: 20px 28px;
        // border-bottom: 1px solid #e9ecef;
        border: 2px solid #CBD9DB;
        color: #495057;
        font-size: 20px;
        vertical-align: top;
        text-align: center;
    }

    .city-cell {
        font-weight: 700;
        color: #2c3e50;
        width: 12%;
        min-width: 80px;
        background: #ABD8D2;
        border-bottom: 2px solid #e9ecef !important;
    }

    .name-cell {
        color: #3498db;
        width: 20%;
        min-width: 150px;
    }

    .address-cell {
        color: #6c757d;
        width: 68%;
        min-width: 300px;
    }
}

.examination-process-box-mobile {
    display: none;
}

.examination-process-box {
    min-height: 730px;
    padding: 40px 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/kslcbg.png');

    .process1 {
        min-height: 320px;
        // margin-top: 30px;
        display: flex;
        flex-flow: row;
        align-items: stretch;
        justify-content: center;

        .exam-prep-container {
            width: 350px;
            // height: 320px;
            background: #FFFFFF;
            border-radius: 30px;
            border: 2px solid #CBD9DB;
            position: relative;

            .number {
                width: 36px;
                height: 36px;
                background: #011E41;
                border-radius: 50%;
                color: #FFFFFF;
                text-align: center;
                line-height: 36px;
                font-weight: 700;
                position: absolute;
                top: -48px;
                left: 50%;
                margin-left: -18px;
            }

            .title {
                width: 302px;
                min-height: 50px;
                line-height: 1.4;
                background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/kslc1.png');
                background-repeat: no-repeat;
                background-size: 100% 100%;
                margin-top: 12px;
                margin-bottom: 2px;
                margin-left: -10px;
                font-size: 22px;
                padding-left: 14px;
            }

            .prep-list {
                list-style: none;
                padding-left: 0;
                margin: 0;
            }

            .prep-item {
                padding: 2px 10px;
                font-weight: 400;
                font-size: 18px;
                color: #011E41;
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: flex-start;
            }

            .prep-item:hover {
                // transform: translateX(5px);
                // box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
                // background-color: #f0f8ff;
            }

            .prep-item::before {
                content: '•';
                color: #0043E0;
                font-weight: bold;
                font-size: 14px;
                margin-right: 12px;
            }

            .item-text {
                font-size: 18px;
                color: #011E41;
                line-height: 1.5;
            }

            .custom-underline {
                // display: inline-block;
                position: relative;
                padding-bottom: 3px; /* 文字与下划线的间距 */
            }

            .custom-underline::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 6px;
                background: linear-gradient(90deg, #50B9AA 0%, #E2CB24 100%);
                /* 可以添加其他效果 */
                border-radius: 4px;
            }
        }

        .exam-prep-container:nth-child(2) {
            margin: 0 40px;
        }

        .exam-prep-container1 {
            .number {
                top: -48px;
            }
        }
    }
    .process1:nth-child(2) {
        margin-top: 80px;
    }
}

.age-modal-content {
    h4 {
        font-weight: 500;
        font-size: 20px;
        color: #011E41;
        line-height: 33px;
        margin-bottom: 22px;
    }

    .tips-box {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: space-between;

        .p1 {
            font-weight: 500;
            font-size: 18px;
            color: #011E41;
            line-height: 33px;
        }

        img {
            width: 188px;
            height: 188px;
            margin: 20px 0;
        }

        .p2 {
            background: #011E41;
            border-radius: 10px;
            padding: 4px 16px;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 33px;
        }
        .zx {
            color: #fff;
            text-align: center;
            font-size: 20px;
            padding: 6px 36px;
            background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/扫码咨询.png');
            background-size: 100% 100%;
        }
    }

    .radio-group {
        ::v-deep .el-radio__inner {
            display: none;
        }

        .el-radio-group {
            line-height: 50px;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;

            .el-radio {
                margin: 10px 0;
                width: 600px;
                height: 50px;
                background: #FAFCFF;
                border-radius: 10px;
                border: 1px solid #78A0D0;
                display: flex;
                flex-flow: row;
                align-items: center;
                padding: 0 20px;

                >>>.el-radio__label {
                    width: 100%;
                    font-size: 16px;
                }
            }

            .custom-radio-item {
                width: 100%;
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: space-between;

                >span {
                    flex: 1;
                    max-width: 90%;
                }
            }

            i {
                font-size: 30px;
                // color: #fff;
                // border: 1px solid #011E41;
                // border-radius: 50%;
            }
        }
    }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
    .content {
        max-width: 900px;
    }

    .exam-section {
        padding: 0 20px;
    }

    .exam-section:last-child {
        padding: 0;
    }
}

#mobileNavToggle, .mobileProfileIcon, #mobileLangs, .mobile-service-info, .service-body.no-agenda .service-info.mobile-service-info {
    display: none;
}

/* 手机类 */
@media (max-width: 640px) {
    header .top {
        background: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/bgm.png');
        background-size: cover;
        padding: 0 16px;
        min-height: 99vh;
    }
    .page-top-btn {
        width: 100%;
        margin: 0 auto;
        display: grid;
        gap: 0;
        grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
        .top-content4, .top-content5 {
            // width: 46vw;
            // height: 10.8vw;
            // line-height: 10.8vw;
            padding: 1vw 2.6vw;
            font-size: 3.6vw;
            margin: 3vw auto;
            border-radius: 6vw;
            img {
                width: 5.8vw;
                height: 5.8vw;
                margin-left: 1vw;
            }
        }
        .top-content5 {
            background: #00ae8f;
        }

    }
   
    .content {
        width: 100%;
        box-sizing: border-box;
    }

    .top-content h1 {
        font-size: 6.8vw;
    }

    .top-content .h3 {
        font-size: 4vw;
        // height: 6.4vw;
    }

    .top-content2, .top-content3 {
        font-size: 3vw;
    }

    .content-2 {
        margin: 3vh 0;
        width: 100vw;
        min-height: 16.8vw;
        overflow: hidden;
        font-size: 5vw;
    }

    .section-title {
        font-size: 5vw;
        letter-spacing: 2px;

        &::before,
        &::after {
            width: 4px;
            height: 4px;
            margin: 0 2vw;
            box-shadow:
                6px 0 0 #011E41,
                12px 0 0 #011E41,
                0 6px 0 #011E41,
                6px 6px 0 #011E41,
                12px 6px 0 #011E41;
        }
    }

    .content-2 p {
        width: 10vw;
        margin: 0 1vw;
    }

    .content-mobile p {
        width: 6vw;
    }

    .exam-details {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(49%, 1fr));
        gap: 6px;
        padding: 0 2vw;
        .detail-card {
            .top {
                min-height: 18vw;
                .text {
                    font-size: 4vw;
                    img {
                        width: 6.6vw;
                        height: 6.6vw;
                    }
                }
            } 
            .bottom p {
                font-size: 3.8vw;
            }
        }
    }
       
    // .exam-details .detail-card .top {
    //         min-height: 18vw;
    // } 

    // .exam-details .detail-card .top .text img {
    //     width: 6.6vw;
    //     height: 6.6vw;
    // }

    // .exam-details .detail-card .top .text {
    //     font-size: 4vw;
    // }

    .exam-details .detail-card .bottom p {
        font-size: 3.8vw;
    }

    .detail-card .bottom .p2 {
        margin-top: 0.6vh;
    }

    .detail-card .bottom .p2::after {
        top: 0.28vw;
    }

    .exam-details .detail-card .bottom ul li {
        font-size: 3vw;
    }

    .detail-card .bottom {
        padding: 2.8vw;
    }

    .exam-details1 {
        width: 100%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
        gap: 16px;
        padding: 0 2vw;
    }

    .exam-details1 .detail-card1 .left img {
        width: 18vw;
        height: 10vw;
    }

    .detail-card1 {
        width: 100%;
        box-sizing: border-box;
    }

    .detail-card1.right {
        flex: 1;
    }

    .exam-details1 .detail-card1 .right p:first-child {
        font-size: 3.6vw;
    }

    .exam-details1 .detail-card1 .right p:last-child {
        font-size: 3.6vw;
        line-height: 22px;
    }

    .exam-section {
        width: 100%;
        // margin-bottom: 8vh;
        margin-top: 0;
    }

    .exam-section .liucheng {
        display: none;
    }

    .exam-section .liucheng1 {
        display: block;
    }

    .exam-section >h3, .exam-section .h4 {
        height: 14vw;
        min-height: 50px;
        margin: 3vh 0;
        font-size: 5vw;

        &::before,
        &::after {
            width: 10vw;
            height: 10vw;
            border-width: 4px;
        }
    }

    .section-title--light {
        font-size: 4.5vw;

        &::before,
        &::after {
            width: 4px;
            height: 4px;
            margin: 0 3vw;
            box-shadow:
                6px 0 0 #fff,
                12px 0 0 #fff,
                0 6px 0 #fff,
                6px 6px 0 #fff,
                12px 6px 0 #fff;
        }
    }

    .exam-section:nth-child(4) {
        margin: 0 !important;
    }

    footer {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        padding: 16px;
        min-height: 32vh;
    }

    .footer-content {
        display: flex;
        margin: 0;
    }

    .footer-content > p {
        font-size: 3vw !important;
    }

    .footer-content > p:last-child {
        line-height: 2.6vh;
    }

    .exam-centers-container {
        display: none;
    }

    .exam-locations {
        display: block;
        padding: 2vw 2vw;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
        color: #333;
        margin-bottom: 6.8vh;
    }

    .location-list {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .location-card {
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
        border: 1px solid #eaeaea;
        display: flex;
        flex-flow: row;
    }

    .city-header {
        background: #011E41;
        padding: 0 1vw;
        color: white;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: center;
    }

    .city-title {
        font-size: 3.8vw;
        font-weight: 600;
        text-align: center;
        min-width: 21vw;
    }

    .location-details {
        width: 100%;
        padding: 4vw 1.6vw;
        border: 1px solid #CBD9DB;
        border-left: none;
        background: #F5F9FA;
    }

    .location-name {
        font-size: 3.7vw;
        font-weight: 600;
    }

    .location-address {
        font-size: 3.6vw;
    }

    .examination-process-box {
        display: none;
    }

    .examination-process-box-mobile {
        display: block;
        padding: 1vw 2.2vw;
       
        .process1 {
            // height: 320px;
            // margin-top: 12px;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;

          

            .exam-prep-container {
                width: 48vw;
                min-height: 53vw;
                background: #FFFFFF;
                border-radius: 3vw;
                border: 2px solid #CBD9DB;

                // margin-bottom: 4vw;
                .number {
                    width: 4vw;
                    height: 4vw;
                    line-height: 4vw;
                    background: #011E41;
                    border-radius: 50%;
                    color: #FFFFFF;
                    text-align: center;
                    font-weight: 700;
                    position: absolute;
                    top: 50%;
                    margin-top: -2.5vw;
                    left: 0.4vw;
                    font-size: 2.6vw;
                }

                .title {
                    // width: 80vw;
                    // height: 50px;
                    // line-height: 50px;
                    background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/kslc1.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    margin-top: 1.8vw;
                    // margin-bottom: 1vw;
                    margin-left: -1.8vw;
                    font-size: 3.2vw;
                    padding: 1vw 1vw 1vw 5.6vw;
                    position: relative;
                }

                .prep-list {
                    list-style: none;
                    padding-left: 0;
                    margin: 0;
                }

                .prep-item {
                    padding: 0.4vw 1vw;
                    font-weight: 400;
                    font-size: 3vw;
                    color: #011E41;
                    display: flex;
                    flex-flow: row;
                    align-items: center;
                    justify-content: flex-start;
                }

                .prep-item:hover {
                    // transform: translateX(5px);
                    // box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
                    // background-color: #f0f8ff;
                }

                .prep-item::before {
                    content: '•';
                    color: #0043E0;
                    font-weight: bold;
                    font-size: 2vw;
                    margin-right: 1vw;
                }

                .item-text {
                    font-size: 2.8vw;
                    color: #011E41;
                }

                .custom-underline {
                    display: inline-block;
                    position: relative;
                    padding-bottom: 3px; /* 文字与下划线的间距 */
                }

                .custom-underline::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 6px;
                    background: linear-gradient(90deg, #50B9AA 0%, #E2CB24 100%);
                    /* 可以添加其他效果 */
                    border-radius: 4px;
                }
            }
            .exam-prep-container1 {
                width: 46vw;
                height: 28vw;
            }
        }

        .arrow {
            width: 2.8vw;
            margin: 0 1vw;
        }

        .arrow1 {
        }

        .arrow2 {
            transform: rotate(90deg);
            text-align: right;
        }

        .arrow3 {
            transform: rotate(180deg);
        }

        .arrow4 {
            transform: rotate(90deg);
        }

        .arrow-box {
            width: 100%;
            text-align: right;
            margin: 1vw 0;

            .arrow {
                margin-right: 18vw;
            }
        }

        .arrow-box1 {
            text-align: left;

            .arrow {
                margin-left: 18vw;
            }
        }
    }

    .age-modal-content {
        h4 {
            font-size: 4vw;
        }

        .tips-box {
            .p1 {
                font-size: 3.8vw;
                line-height: 4.8vw;
            }

            img {
                width: 50vw;
                height: 50vw;
            }

            .p2 {
                border-radius: 3vw;
                padding: 1vw 2vw;
                font-size: 3.8vw;
            }
            .zx {
                font-size: 4vw;
                padding: 6px 46px;
            }
        }

        .radio-group {
            ::v-deep .el-radio__inner {
                display: none;
            }

            .el-radio-group {
                .el-radio {
                    margin: 2vw 0;
                    width: 80vw;
                    height: 18vw;
                    border-radius: 10px;
                    border: 1px solid #78A0D0;
                    padding: 0 1vw;
                }

                .custom-radio-item {
                    width: 100%;
                    display: flex;
                    flex-flow: row;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    >span {
                        font-size: 3.8vw;
                        // text-wrap: wrap;
                        display: flex;
                        flex-flow: column;

                        >span {
                            font-size: 3vw;
                            color: #52739B;
                            margin-top: 1vw;
                        }
                    }
                }

                i {
                    font-size: 6vw;
                    // color: #fff;
                    // border: 1px solid #011E41;
                    // border-radius: 50%;
                }
            }
        }
    }
    .dot-matrix-gradient {
        width: 12vw;
        height: 9vw;
    }
}
</style>
